// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cad68539","239":"36849629","453":"c7560776","455":"32575653"}[chunkId] + ".chunk.js";
};